import { AddToWatchlistPrefill } from '../../modules/Investor/Portfolio/components/AddToWatchlist/prefillBuilder';

/**
 * Comma-joins the fields of an Add Lead prefill into the single-line text expected by the
 * Bulk Add textarea. Order: company name -> identifier -> website -> brand. Empty fields are
 * skipped and the identifier is deduped against the name (the raw-text search fallback sets
 * name === identifier, which collapses to a single token).
 */
export const buildBulkAddPrefillText = (prefill: AddToWatchlistPrefill = {}): string => {
    const name = (prefill.identifierDisplay || '').trim();
    const rawIdentifier = (prefill.identifierPayload || '').trim();
    const identifier = rawIdentifier && rawIdentifier !== name ? rawIdentifier : '';
    const website = (prefill.website || '').trim();
    const brand = (prefill.brand || '').trim();

    return [name, identifier, website, brand].filter(Boolean).join(', ');
};
